
(function(template){
    define('vue!loginVueApp/components/Dropdown',['Vue'],function(Vue){
        return {
            name: 'Dropdown',
            template:template,
            props: ['options','selected', 'labelName', 'isRequired'],
            methods: {
                handleSelect: function(val){
                    this.$emit('update:selected',val.target.value)
                }
            }
        }
    })
})('<div class="drop-down"> <select :id="labelName" @change="handleSelect($event)" :required=isRequired> <option class="dropdown-item" v-for="(optionName) in options" :key="optionName.name" :id="optionName.val" :value="optionName.val" >{{optionName.name}}</option> </select> <label class="drop-down-label" :for="labelName">{{isRequired ? labelName + \'*\' : labelName}}</label> </div>');
